import HttpService from "./HttpService";

const httpService = HttpService.getInstance();

export default {
  show: id => httpService.authCall("GET", `/api/news/${id}`),
  index: (params) => httpService.authCall('GET', '/api/news', {params}),
}
